import request from '@/utils/request'

/**
 * 查询折线图数据
 * @param {Object} data - 查询参数
 * @param {String} data.startDate - 开始日期 (YYYY-MM-DD)
 * @param {String} data.endDate - 结束日期 (YYYY-MM-DD)
 * @param {Array<Number>} data.pageTypes - 页面类型列表 [1, 2]
 * @param {Array<String>} data.metricTypes - 指标类型列表 ["COUNT", "IP"]
 * @returns {Promise}
 */
export function getChartData(data) {
  return request({
    url: '/admin/ip-statistics/chart',
    method: 'post',
    data: data
  })
}

/**
 * 分页查询访问记录
 * @param {Object} data - 查询参数
 * @param {Number} data.page - 页码（从1开始）
 * @param {Number} data.limit - 每页条数
 * @param {Array<Number>} data.pageTypes - 页面类型列表
 * @param {String} [data.date] - 查询日期 (YYYY-MM-DD)，可选
 * @returns {Promise}
 */
export function getPageData(data) {
  return request({
    url: '/admin/ip-statistics/page',
    method: 'post',
    data: data
  })
}

/**
 * 导出访问记录
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportData(data) {
  return request({
    url: '/admin/ip-statistics/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
